<div id="change-document" class="change-document">
    <div class="body bil-font-regular-large bil-font-weight box-padding"
        [ngClass]="{'box-padding-mobile' : isMobile, 'box-padding': !isMobile}">
        Please check the document(s) uploaded:
    </div>
    <div *ngFor="let message of data.messages" class="bil-font-regular-large bil-font-weight delete-itr-box-padding bil-error-message">
        &#8226; {{message.year}}: {{message.message}}
    </div>
    <div id="footer" class="bil-space-center bil-flex-wrap"
        [ngClass]="{'box-padding-mobile' : isMobile, 'box-padding': !isMobile}">
        <span>
            <button type="button" mat-raised-button color="primary" class="bil-right-float"
                (click)="close()">Retry</button>
        </span>
    </div>
</div>